import request from "@/utils/request";


// 进口柜子列表
export function getImportOrderContainerList(params,data){
	return request({
		url:'/importexportorder/dispatchapp/api/importOrder/v2/containerPage',
		method:'POST',
		params,
		data
	})
}

// 出口柜子列表
export function getExportOrderContainerList(params,data){
	return request({
		url:'/importexportorder/dispatchapp/api/exportOrder/v2/containerPage',
		method:'POST',
		params,
		data
	})
}
